/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Injectable} from "@angular/core";
import {Router} from "@angular/router";

import {AuthenticationService} from "./authentication.service";
import {BaseService} from "./base-service";

import {Rule} from "../models/rule";
import { PagedResults } from "app/models/paged-results";
import { RestService } from "./rest-service";
import { Url_Base } from "app/rest-constants";


@Injectable()
export class RulesService extends BaseService {


  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private mRestService: RestService
  ) {
    super(router, authenticationService);
  }


  private getUrl(): string {
    return `${Url_Base}/rules/`;
  }


  getNumberRules(): Promise<Number> {
    const callUrl = this.getUrl() + 'count';
    return this.mRestService.get<Number>(callUrl);
  }

  getAllRulesForPagingOld(start: number, size: number, order: String, filterString: String): Promise<Rule[]> {
    const callUrl = this.getUrl() + '?start=' + start + "&size=" + size + "&order=ASC&filterString=" + filterString;

    return this.mRestService.get<Rule[]>(callUrl);
  }


  getAllRulesForPaging(start: number, size: number, order: String, filterString: String): Promise<PagedResults<Rule>> {
    const callUrl = this.getUrl() + 'paging?start=' + start + "&size=" + size + "&order=ASC&filterColumn=name&filterString=" + filterString;

    return this.mRestService.get<PagedResults<Rule>>(callUrl);
  }

  getAllRules(): Promise<Rule[]> {
    const callUrl = this.getUrl();
    return this.mRestService.get<Rule[]>(callUrl);
  }

  getRuleById(id: number): Promise<Rule> {
    const callUrl = this.getUrl() + `${id}`;
    return this.mRestService.get<Rule>(callUrl);
  }

  createRule(rule: Rule): Promise<Rule> {
    const callUrl = this.getUrl();
    return this.mRestService.post<Rule>(callUrl, rule);
  }

  updateRule(rule: Rule): Promise<Rule> {
    const callUrl = this.getUrl();
    return this.mRestService.put<Rule>(callUrl, rule);
  }

  validateRule(rule: Rule): Promise<Rule> {
    const callUrl = this.getUrl() + `validate`;
    return this.mRestService.post<Rule>(callUrl, rule);
  }

  deleteRuleById(id: number): Promise<void> {
    const callUrl = this.getUrl() + `${id}`;
    return this.mRestService.delete(callUrl);
  }

  startRule(id: number): Promise<void> {
    const callUrl = this.getUrl() + `${id}/start`;
    return this.mRestService.get(callUrl);
  }

  stopRule(id: number): Promise<void> {
    const callUrl = this.getUrl() + `${id}/stop`;
    return this.mRestService.get(callUrl);
  }

}
